import { http } from './client';
import type { ApiKeyScope, BotApiKey, BotApiKeyWithToken } from './types';

export const apiKeysApi = {
  async listForBot(botId: string): Promise<{ items: BotApiKey[] }> {
    const res = await http.get<{ items: BotApiKey[] }>(
      `/v1/org/bots/${encodeURIComponent(botId)}/api-keys`,
    );
    return res.data;
  },
  async mint(botId: string, label: string, scope: ApiKeyScope = 'full'): Promise<BotApiKeyWithToken> {
    const res = await http.post<BotApiKeyWithToken>(
      `/v1/org/bots/${encodeURIComponent(botId)}/api-keys`,
      { label, scope },
    );
    return res.data;
  },
  async revoke(botId: string, keyHash: string): Promise<{ revoked: true; keyHash: string }> {
    const res = await http.delete<{ revoked: true; keyHash: string }>(
      `/v1/org/bots/${encodeURIComponent(botId)}/api-keys/${encodeURIComponent(keyHash)}`,
    );
    return res.data;
  },
  async reveal(botId: string, keyHash: string): Promise<{ token: string | null }> {
    const res = await http.get<{ token: string | null }>(
      `/v1/org/bots/${encodeURIComponent(botId)}/api-keys/${encodeURIComponent(keyHash)}/reveal`,
    );
    return res.data;
  },
};
